import React from 'react';
import { IconProps } from './typing';

const Trash = ({
  iconSize = 24,
  background = 'none',
  color = '#E4002C',
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={iconSize}
    height={iconSize}
    viewBox={`0 0 ${iconSize} ${iconSize}`}
    fill={background}
  >
    <path
      d="M17.5195 5.33008H22V6.66992H20V21.4404C19.9998 22.3017 19.3017 22.9998 18.4404 23H5.55957C5.14599 22.9999 4.74949 22.8354 4.45703 22.543C4.16458 22.2505 4.00009 21.854 4 21.4404V6.66992H2V5.33008H6.51953L7.51953 1.33008H16.5195L17.5195 5.33008ZM5.33008 21.4404C5.33027 21.5672 5.43286 21.6697 5.55957 21.6699H18.4404C18.5671 21.6697 18.6697 21.5672 18.6699 21.4404V6.66992H5.33008V21.4404ZM9.66016 18H8.33008V10H9.66016V18ZM12.6602 18H11.3301V10H12.6602V18ZM15.6602 18H14.3301V10H15.6602V18ZM7.84961 5.33008H16.1904L15.5195 2.66992H8.51953L7.84961 5.33008Z"
      fill={color}
    />
  </svg>
);

export default Trash;
